document.addEventListener("submit", function(event) {
  var target = event.target;

  if (target.matches(".js-back-in-stock-form")) {
    event.preventDefault();

    var form = target,
      actionUrl = form.getAttribute("action"),
      parentContainer = form.parentElement;

    fetch(actionUrl, {
      method: 'POST',
      headers: {
        "accept": 'application/json',
        "revision": '2024-06-15',
        "content-type": 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: form.querySelector('[name="email"]').value
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${form.querySelector('[name="variant"]').value}`
              }
            }
          }
        }
      }),
    })
    .then((response) => {
      if(response.status === 202) {
        parentContainer.querySelector(".popup-bis__body").style.display = "none";
        parentContainer.querySelector(".js-popup-success-text").style.display = "block";

        setTimeout(function() {
          parentContainer.classList.remove("is-active");
        }, 3000);

        setTimeout(function() {
          parentContainer.querySelector(".popup-bis__body").style.display = "block";
          parentContainer.querySelector(".js-popup-success-text").style.display = "none";
          form.querySelector('input[type="email"]').value = "";
          form.querySelector('button[type="submit"]').classList.remove("btn--loading");
        }, 4000);
      }
    })
    .catch((e) => {
      console.log(e);
    });
  }
});

document.addEventListener("click", function(event) {
  var target = event.target;

  if (target.matches(".js-disabled-swatches-back-in-stock label")) {
    var label = target;
    var input = label.parentElement.querySelector("input");

    input.checked = true;

    if (input.getAttribute("data-available") === "true") {
      document.querySelector(".js-bis").classList.add("hidden");
      document.querySelector(".js-product-submit").classList.remove("hidden");
    } else {
      document.querySelector(".js-bis").classList.remove("hidden");
      document.querySelector(".js-product-submit").classList.add("hidden");
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var doc = document;
  var elements = doc.querySelectorAll('.js-bis-click');

  elements.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      var elementTarget = doc.querySelector(element.getAttribute('href'));

      if (!elementTarget || element.classList.contains('js-siblings-link', 'is-active')) {
        return;
      }

      elementTarget.classList.toggle('is-active');
    });
  });

});
